<template>
  <li :class="lineColorClass" v-if="score !== null">{{ label[labelType] }}</li>
</template>

<script>
export default {
  name: "SystemScoreDescriptionRow",
  props: {
    label: {
      type: Object,
      default: () => ({})
    },
    score: {
      type: Number,
      default: 0
    }
  },
  computed: {
    labelType() {
      if (this.score === 10) {
        return 'good';
      }
      if (this.score >= 5) {
        return 'neutral';
      }
      return 'bad'
    },
    lineColorClass() {
      if (this.score === 5) {
        return 'amber--text text--darken-2';
      }
      if (this.score === 0) {
        return 'red--text text--accent-4'
      }
      return 'teal--text text--darken-2';
    }
  },
}
</script>

<style scoped>

</style>